import {Pipe, PipeTransform} from '@angular/core';
import {FilterByPipe} from 'ngx-pipes';

@Pipe({
  name: 'find',
  standalone: true
})
export class FindPipe implements PipeTransform {
  constructor(private filterByPipe: FilterByPipe) {
  }

  transform<T>(input: Iterable<T>, props: Array<string> | string, search?: any, strict: boolean = true): T {
    if (!input) {
      return input as any;
    }
    let propsArray = [];
    if (typeof props === 'string') {
      propsArray = [props];
    } else {
      propsArray = props;
    }
    if (search === null) {
      search = '';
    }

    const ts = this.filterByPipe.transform<T[]>([...input] || [], propsArray, search, strict);
    if (ts.length > 0) {
      return ts[0];
    }
    return null;
  }
}

